<template>
    <Menu
        as="div"
        class="relative flex h-auto"
        :class="{ 'max-sm:hidden': hideForMobile }"
    >
        <MenuButton
            class="gap-2 flex rounded-lg border-2 border-transparent text-slate-700 items-center max-sm:focus:ring-2 max-sm:focus:ring-slate-300 focus:outline-none active:outline-none focus:border-slate-300"
            @click="handleClick"
            @keydown.enter.prevent="handleClick"
        >
            <!-- start left icon -->
            <div class="w-5 hidden sm:block">
                <slot name="icon-left"></slot>
            </div>
            <!-- end left icon -->
            <div
                class="gap-1 flex rounded max-sm:bg-white shadow sm:shadow-none border border-slate-300 pl-4 pr-3 py-2 sm:border-0 sm:p-0"
            >
                <p class="text-slate-800 text-sm font-medium leading-tight">
                    <slot name="button-text"></slot>
                </p>
                <div
                    v-show="!customClickEvent"
                    class="w-5 flex items-center ml-1"
                >
                    <i class="fa-solid fa-xs fa-chevron-down"></i>
                </div>
            </div>
        </MenuButton>
        <transition
            enter-active-class="transition duration-100 ease-out"
            enter-from-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in"
            leave-from-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0"
        >
            <MenuItems class="absolute right-0 z-10 mt-2 w-56 origin-top-right">
                <slot name="menu-items"></slot>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems } from '@headlessui/vue';

export default {
    components: { Menu, MenuButton, MenuItems },
    props: {
        customClickEvent: {
            type: Boolean,
            default: false,
        },
        hideForMobile: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['buttonClicked'],
    setup(props, { emit }) {
        const handleClick = () => {
            if (props.customClickEvent) {
                emit('buttonClicked');
            }
        };
        return { handleClick };
    },
};
</script>
